import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const CheckboxDisabledIcon = (props: SvgIconProps) => {
    const { gray200, gray300 } = colors;

    return (
        <SvgIcon {...props}>
            <rect
                x="2.5"
                y="2.5"
                width="19"
                height="19"
                rx="5.5"
                fill={gray200}
                stroke={gray300}
            />
        </SvgIcon>
    );
};

export default CheckboxDisabledIcon;
